import { ref } from '@vue/composition-api'
import store from '@/store'

export default function useWorkplaceContractEffectiveDate(refetchData) {
  const loading = ref(false)
  const contractEffectiveDateModal = ref(null)

  const workplaceContractEffectiveDate = ref({
    workplace_id: null,
    workplace_name: null,
    contract_effective_date: '',
  })

  function show(workplace) {
    workplaceContractEffectiveDate.value.workplace_id = workplace.id
    workplaceContractEffectiveDate.value.workplace_name = workplace.name
    workplaceContractEffectiveDate.value.contract_effective_date = null
    contractEffectiveDateModal.value.show()
  }

  function editContractEffectiveDate() {
    loading.value = true
    const payload = workplaceContractEffectiveDate.value
    store.dispatch('app-institution/editContractEffectiveDate', payload)
      .then(() => {
        refetchData()
        loading.value = false
        contractEffectiveDateModal.value.hide()
      }).catch(() => {
        loading.value = false
      })
  }

  return {
    loading,
    contractEffectiveDateModal,
    workplaceContractEffectiveDate,
    show,
    editContractEffectiveDate,
  }
}
